import React, { useEffect, useState } from "react";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import GuideContentArea from "../../../core/common/GuideContentArea";
import { Button, Checkbox, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import { EyeOutlined } from "@ant-design/icons";
import Datatable from "../../../core/common/dataTable";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import Footer from "../../../core/common/Footer";
import SearchableSelect from "../../../core/common/SearchableSelect";
import { all_routes } from "../../router/all_routes";
import { useLocation } from "react-router";
import { SearchPayloadType } from "../../admin/reusable/FiltersTrackCase";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import Loading from "../../../core/common/custom-loading/Loading";
import CaseActionModal from "./CaseActionModal";
import CaseTimelineModal from "./CaseTimelineModal";

interface TableDataInterface {
  assignment_template_id: string;
  assignment_id?: string;
  case_id?: string;
  check_name?: string;
  key_value?: string;
  status?: string;
  start_date?: string;
}

// guideData
const guideData = [
  "Search for the candidates package by candidate name or case ID.",
  "The candidates existing package will show up with the current status of the existing checks and key value (company name/university name/address).",
  "Select the checks that you would like to stop and provide a reason. In case you want to stop the entire case select all the checks. Charges apply as per contractual obligations. Checks are stopped after a timeline.",
  "You will have an option to resume the case or check at a later date. In case you resume at a later date - charges will be applicable as per the contractual obligations.",
  "Any CANDIDATE_SUBMITTED case which has complete checks cannot be stopped.",
  "Any complete case where all checks have been complete will not be visible in the search.",
];

// breadcrumb data
const breadcrumbItem = [
  { label: "Live Case Progress" },
  { label: "Case Details" },
  { label: "Stop Check" },
];

const ManagerStopCheck = () => {
  const location = useLocation();

  const [actionType, setActionType] = useState<
    "STOPPED" | "CANCELLED" | "CANDIDATE_SUBMITTED"
  >("STOPPED");

  const assignment_id = location.state?.assignment_id;
  const AllCaseDetails = location.state?.caseDetails;
  const caseID = AllCaseDetails?.case_id;
  const [showGuide, setShowGuide] = useState<boolean>(false);
  const [caseInfo, setCaseInfo] = useState<any>({});

  const [checkHistory, setCheckHistory] = useState<TableDataInterface[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [lastSearchPayload, setLastSearchPayload] = useState<
    Partial<SearchPayloadType>
  >({});
  const [stopModalRecord, setStopModalRecord] = useState<any>(null);
  const [stopLoading, setStopLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [timelineLoading, setTimelineLoading] = useState<boolean>(false);
  const getChecksHistoryAPI = useApi<any>(
    assignment_id
      ? `/api/v1/candidate/forms/case-check-summary/${assignment_id}`
      : "",
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );
  const fetchCheckHistory = async (
    searchPayload: Partial<SearchPayloadType> = {},
    page: number = pagination.page,
    limit: number = pagination.limit,
  ) => {
    if (!assignment_id) return;

    try {
      const res = await getChecksHistoryAPI.callApi();
      const historyList = Array.isArray(res?.data?.checks)
        ? res.data.checks
        : [];

      setCheckHistory(historyList);
      setTotal(historyList.length);
      setLastSearchPayload(searchPayload);

      setCaseInfo({
        case_id: res?.data?.case_id,
        candidate_name: res?.data?.candidate_name,
        case_receive_date: res?.data?.case_receive_date,
        sla_start_date: res?.data?.sla_start_date,
        due_date: res?.data?.due_date,
      });
    } catch (error) {
      console.error(error);
      setCheckHistory([]);
      setTotal(0);
      setCaseInfo({});
    }
  };
  useEffect(() => {
    if (assignment_id) {
      fetchCheckHistory();
    }
  }, [assignment_id]);

  const caseStatusUpdateAPI = useApi<any>(webservice_url.GetCheckStatus, {
    method: "PATCH",
    autoCall: false,
    handleGlobalError: false,
  });

  const handleTableChange = (
    page: number,
    limit: number = pagination.limit,
  ) => {
    setPagination({ page, limit });
    fetchCheckHistory(lastSearchPayload, page, limit);
  };

  const handleAction = (
    record: any,
    action: "STOPPED" | "CANCELLED" | "CANDIDATE_SUBMITTED",
  ) => {
    setActionType(action);
    setStopModalRecord({ ...record, ...caseInfo });
  };

  const handleConfirmStop = async (reason: string) => {
    if (!stopModalRecord) return;

    try {
      setStopLoading(true);

      await caseStatusUpdateAPI.callApi({
        case_id: AllCaseDetails?.case_id,
        check_id: stopModalRecord.assignment_template_id,
        status: actionType,
        remarks: reason,
      });

      await fetchCheckHistory();

      setStopModalRecord(null);

      let title = "";
      let text = "";

      if (actionType === "STOPPED") {
        title = "Stopped!";
        text = "The check has been stopped successfully.";
      } else if (actionType === "CANCELLED") {
        title = "Cancelled!";
        text = "The check has been cancelled successfully.";
      } else {
        title = "Resumed!";
        text = "The check has been resumed successfully.";
      }

      await Swal.fire({
        title,
        text,
        icon: "success",
        timer: 1500,
        showConfirmButton: true,
        // showConfirmButton: false,
      });
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    } finally {
      setStopLoading(false);
    }
  };

  // const getCaseLog = useApi<any>(webservice_url.ViewLogAPI, {
  //   method: "POST",
  //   autoCall: false,
  //   handleGlobalError: false,
  // });

  // const handleViewLog = async (caseID?: string) => {
  //   if (!caseID) return;
  //   setShowTimeline(true);
  //   setTimelineLoading(true);
  //   try {
  //     const res = await getCaseLog.callApi({ case_id: caseID });
  //     setTimelineData(res?.data ?? []);
  //   } catch (err) {
  //     console.error(err);
  //     setTimelineData([]);
  //   } finally {
  //     setTimelineLoading(false);
  //   }
  // };

    const getCaseLog = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

   const handleViewLog = async (assignmentTemplateId?: string) => {
    if (!assignmentTemplateId) return;

    setShowTimeline(true);
    setTimelineLoading(true);

    try {
      const res = await getCaseLog.callApi(
        undefined,
        `/api/v1/candidate/forms/timeline/${assignmentTemplateId}`,
      );

      setTimelineData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setTimelineData([]);
    } finally {
      setTimelineLoading(false);
    }
  };

  const renderStatusBadge = (value: string) => {
    const normalized = (value || "").toUpperCase();
    let badgeClass = "sc-badge sc-badge-neutral";

    if (normalized.includes("CANCELLED")) {
      badgeClass = "sc-badge sc-badge-danger";
    } else if (normalized.includes("STOP")) {
      badgeClass = "sc-badge sc-badge-warning";
    } else if (
      normalized.includes("CANDIDATE_SUBMITTED") ||
      normalized.includes("COMPLETE")
    ) {
      badgeClass = "sc-badge sc-badge-success";
    } else if (normalized.includes("LOGGED IN")) {
      badgeClass = "sc-badge sc-badge-info";
    }

    return <span className={badgeClass}>{value || "-"}</span>;
  };

  const formatStatus = (status: string) => {
    if (!status) return "-";

    return status
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "srNo",
      onCell: () => cellWidth(100),
      align: "center",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Check Type",
      dataIndex: "check_name",
      key: "check_name",
      align: "center",
      onCell: () => cellWidth(180),
    },
    {
      title: "Key Value",
      dataIndex: "key_value",
      key: "key_value",
      align: "center",
      onCell: () => cellWidth(140),
      render: (value: string) =>
        value ? value : <span className="sc-empty-value">-</span>,
    },
    {
      title: "Check Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      onCell: () => cellWidth(200),
      render: (value: string) => renderStatusBadge(formatStatus(value)),
    },
    {
      title: "SLA Start Date",
      dataIndex: "start_date",
      key: "start_date",
      align: "center",
      onCell: () => cellWidth(160),
      render: (value: string) =>
        value ? dayjs(value).format("DD-MM-YYYY") : "-",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      onCell: () => cellWidth(180),
      render: (_: any, record: any) => {
        // Cancelled
        if (record.status === "CANCELLED") {
          return (
            <div className="d-flex flex-column gap-2 align-items-stretch">
              <button className="btn btn-danger btn-sm sc-action-btn" disabled>
                <i className="ti ti-x me-1"></i>Cancelled
              </button>
              <button
                className="btn btn-success btn-sm sc-action-btn"
                onClick={() => handleAction(record, "CANDIDATE_SUBMITTED")}
              >
                <i className="ti ti-player-play me-1"></i>Resume Check
              </button>
            </div>
          );
        }

        // Stopped -> Resume + Cancel
        if (record.status === "STOPPED" || record.status === "STOP") {
          return (
            <div className="d-flex flex-column gap-2 align-items-stretch">
              <button
                className="btn btn-success btn-sm sc-action-btn"
                onClick={() => handleAction(record, "CANDIDATE_SUBMITTED")}
              >
                <i className="ti ti-player-play me-1"></i>Resume Check
              </button>

              <button
                className="btn btn-danger btn-sm sc-action-btn"
                onClick={() => handleAction(record, "CANCELLED")}
              >
                <i className="ti ti-x me-1"></i>Cancel Check
              </button>
            </div>
          );
        }

        // Active -> Stop + Cancel
        return (
          <div className="d-flex flex-column gap-2 align-items-stretch">
            <button
              className="btn btn-warning btn-sm sc-action-btn"
              onClick={() => handleAction(record, "STOPPED")}
            >
              <i className="ti ti-player-pause me-1"></i>Stop Check
            </button>

            <button
              className="btn btn-danger btn-sm sc-action-btn"
              onClick={() => handleAction(record, "CANCELLED")}
            >
              <i className="ti ti-x me-1"></i>Cancel Check
            </button>
          </div>
        );
      },
    },
    {
      title: "View Log",
      key: "viewLog",
      align: "center",
      onCell: () => cellWidth(110),
      render: (_: any, record: any) => (
        <div
          className="sc-view-log-icon text-center"
          // onClick={() => handleViewLog(caseID)}
          onClick={() => handleViewLog(record?.assignment_template_id)}
        >
          <i className="ti ti-eye"></i>
        </div>
      ),
    },
  ];

   const loader = getChecksHistoryAPI.loading;

  return (
    <>
      <style>{`
        .sc-card {
          border: 1px solid #eef0f3;
          border-radius: 14px;
          box-shadow: 0 2px 10px rgba(20, 20, 43, 0.04);
          overflow: hidden;
          transition: box-shadow 0.2s ease;
        }
        .sc-card:hover {
          box-shadow: 0 6px 18px rgba(20, 20, 43, 0.07);
        }
        .sc-card-header {
          background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);
          border-bottom: 1px solid #eef0f3;
        }
        .sc-section-badge {
          display: inline-flex;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #4338ca;
          margin-right: 10px;
          flex-shrink: 0;
        }
        .sc-badge {
          display: inline-block;
          padding: 0.32rem 0.7rem;
          border-radius: 20px;
          font-size: 0.76rem;
          font-weight: 600;
          letter-spacing: 0.01em;
          white-space: nowrap;
        }
        .sc-badge-neutral {
          background-color: #f1f2f6;
          color: #555b66;
        }
        .sc-badge-success {
          background-color: #e6f7ee;
          color: #16794f;
        }
        .sc-badge-warning {
          background-color: #fff4e0;
          color: #9a6400;
        }
        .sc-badge-danger {
          background-color: #fdeaea;
          color: #b3261e;
        }
        .sc-badge-info {
          background-color: #e8f0fe;
          color: #1a56c4;
        }
        .sc-empty-value {
          color: #b0b5bf;
        }
        .sc-action-btn {
          border-radius: 8px;
          font-weight: 600;
          font-size: 0.78rem;
          padding: 0.4rem 0.75rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.15s ease, box-shadow 0.15s ease;
          border: none;
        }
        .sc-action-btn:not(:disabled):hover {
          transform: translateY(-1px);
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
        }
        .sc-view-log-icon {
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          color: #4b5563;
          transition: background-color 0.15s ease, color 0.15s ease;
        }
        .sc-view-log-icon:hover {
          background-color: #eef2ff;
          color: #4338ca;
        }
        .sc-table-wrapper table {
          font-size: 0.88rem;
        }
      `}</style>

      <div className="page-wrapper">
        <div className="content px-2 px-md-4 pb-5">
          {/* PageBreadcrumb */}
          <PageBreadcrumb
            title="Stop Check"
            breadcrumbs={breadcrumbItem}
            showBackButton={true}
            backRoute={-1}
            showGuideButton={true}
            onGuideClick={() => setShowGuide((prev) => !prev)}
          />
          {/* /PageBreadcrumb */}

          {/* Guide Container */}
          <>
            <GuideContentArea
              showGuide={showGuide}
              handleClick={() => setShowGuide(false)}
              title={"Stop Check"}
              content={
                <div>
                  <ul>
                    {guideData?.map((i, idx) => (
                      <li key={idx} className="pb-2">
                        {idx + 1}. {i}
                      </li>
                    ))}
                  </ul>
                </div>
              }
            />
          </>

          {/* Table  */}
          <div className="card sc-card mt-4">
            <div className="sc-card-header d-flex align-items-center px-3 py-3">
              <span className="sc-section-badge"></span>
              <span className="fw-semibold text-dark">Check Details</span>
            </div>
            {loader ? (
              <div className="py-4">
                <Loading />
              </div>
            ) : (
              <div className="sc-table-wrapper pb-2 px-2 pt-2">
                <Datatable
                  dataSource={checkHistory}
                  columns={columns}
                  Selection={false}
                  hideSizeChanger={true}
                  pagination={{
                    current: pagination.page,
                    pageSize: pagination.limit,
                    total,
                  }}
                  handleTableChange={(pagination: any) => {
                    handleTableChange(pagination.current, pagination.pageSize);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        {/* ---- Footer ---- */}
        <Footer />
      </div>
      {showTimeline && (
        <CaseTimelineModal
          timelineData={timelineData}
          loading={timelineLoading}
          onClose={() => {
            setShowTimeline(false);
            setTimelineData([]);
          }}
        />
      )}
      {stopModalRecord && (
        <CaseActionModal
          isOpen={!!stopModalRecord}
          title={
            actionType === "STOPPED"
              ? "Stop Check"
              : actionType === "CANCELLED"
                ? "Cancel Check"
                : "Resume Check"
          }
          confirmLabel={
            actionType === "STOPPED"
              ? "Stop Check"
              : actionType === "CANCELLED"
                ? "Cancel Check"
                : "Resume Check"
          }
          confirmButtonClass="btn-secondary"
          reasonLabel={
            actionType === "STOPPED"
              ? "Enter reason for stopping check"
              : actionType === "CANCELLED"
                ? "Enter reason for cancelling check"
                : "Enter reason for resuming check"
          }
          onClose={() => setStopModalRecord(null)}
          onConfirm={handleConfirmStop}
          baseFields={[
            { label: "Case ID", value: AllCaseDetails?.case_id },
            { label: "Candidate Name", value: AllCaseDetails.applicant_name },
            {
              label: "Case Receive Date",
              value: AllCaseDetails?.case_receive_date
                ? dayjs(AllCaseDetails.case_receive_date).format("DD-MM-YYYY")
                : "-",
            },
            {
              label: "SLA Start Date",
              value: dayjs(stopModalRecord.sla_start_date).format("DD-MM-YYYY"),
            },
            {
              label: "Due Date",
              value: dayjs(stopModalRecord.due_date).format("DD-MM-YYYY"),
            },
          ]}
          extraFields={
            [
              // { label: "Stop Reason", value: stopModalRecord.action },
            ]
          }
          loading={stopLoading}
        />
      )}
    </>
  );
};
export default ManagerStopCheck;
{
  /* <div className="px-0 col-5 col-lg4">
                <label className="form-label">
                  Select Applicant Name or Case ID
                </label>
                <CommonSelect2
                  name="selectedId"
                  className="select"
                  // showDefaultOption={false}
                  defaultValue={formData?.selectedId}
                  options={applicantsOption}
                  onChange={(option) => {
                    setFormData((prev) => ({
                      ...prev,
                      selectedId: String(option?.value),
                    }));
                  }}
                />
              </div> */
}
